import { render, staticRenderFns } from "./OPGeneralComponent.vue?vue&type=template&id=229f4f0e&"
import script from "./OPGeneralComponent.vue?vue&type=script&lang=js&"
export * from "./OPGeneralComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports